import JwtDecode from "jwt-decode";

const _employeeFilterName = new WeakMap();
const _roleFilterName = new WeakMap();
const _teamFilterName = new WeakMap();
const _sectionFilterName = new WeakMap();
const _cityFilterName = new WeakMap();
const _townFilterName = new WeakMap();
const _regionFilterName = new WeakMap();
const _authData = new WeakMap();
class LocalStorageService {
  constructor() {
    _employeeFilterName.set(this, "employeeFilters");
    _roleFilterName.set(this, "roleFilters");
    _teamFilterName.set(this, "teamFilters");
    _sectionFilterName.set(this, "sectionFilters");
    _cityFilterName.set(this, "cityFilters");
    _townFilterName.set(this, "townFilters");
    _regionFilterName.set(this, "regionFilters");
    _authData.set(this, "authdata");
  }

  get employeeFilters() {
    return this.getItem(_employeeFilterName.get(this));
  }
  set employeeFilters(value) {
    this.setItem(_employeeFilterName.get(this), value);
  }
  clearEmployeeFilters() {
    this.employeeFilters = [];
  }

  get roleFilters() {
    return this.getItem(_roleFilterName.get(this));
  }
  set roleFilters(value) {
    this.setItem(_roleFilterName.get(this), value);
  }
  clearRoleFilters() {
    this.roleFilters = [];
  }

  get sectionFilters() {
    return this.getItem(_sectionFilterName.get(this));
  }
  set sectionFilters(value) {
    this.setItem(_sectionFilterName.get(this), value);
  }
  clearSectionFilters() {
    this.sectionFilters = [];
  }

  get teamFilters() {
    return this.getItem(_teamFilterName.get(this));
  }
  set teamFilters(value) {
    this.setItem(_teamFilterName.get(this), value);
  }
  clearTeamFilters() {
    this.teamFilters = [];
  }

  get teamSectionFilters() {
    return this.getItem(_sectionFilterName.get(this));
  }
  set teamSectionFilters(value) {
    this.setItem(_sectionFilterName.get(this), value);
  }
  clearTeamSectionFilters() {
    this.teamSectionFilters = [];
  }

  get cityFilters() {
    return this.getItem(_cityFilterName.get(this));
  }
  set cityFilters(value) {
    this.setItem(_cityFilterName.get(this), value);
  }
  clearCityFilters() {
    this.cityFilters = [];
  }

  get townFilters() {
    return this.getItem(_townFilterName.get(this));
  }
  set townFilters(value) {
    this.setItem(_townFilterName.get(this), value);
  }
  clearTownFilters() {
    this.townFilters = [];
  }

  get regionFilters() {
    return this.getItem(_regionFilterName.get(this));
  }
  set regionFilters(value) {
    this.setItem(_regionFilterName.get(this), value);
  }
  clearRegionFilters() {
    this.regionFilters = [];
  }

  async setItem(filterName, value) {
    await localStorage.setItem(filterName, JSON.stringify(value));
  }
  getItem(filterName) {
    return JSON.parse(localStorage.getItem(filterName)) || [];
  }

  get authData() {
    try {
    
      return   this.getItem(_authData.get(this));
    } catch (error) {
      return null;
    }
  }
  set authData(value) {
    console.log("token  set=="+JSON.stringify(value)+"__"+_authData.get(this));
    this.setItem(_authData.get(this), value);
  }

  getCurrentUser() {
    try {
      const decode = JwtDecode(this.authData);
      return decode;
    } catch (error) {
      return null;
    }
  }

  isAuthorize(menuId) {
    const user = this.getCurrentUser();
    let found = false;
    if (user)
      JSON.parse(user.Roles).forEach((role) => {
        if (role.Menus.find((m) => m.Id === menuId) != null) found = true;
      });
    return found;
  }

  getSectionId() {
    const user = this.getCurrentUser();
    return user.sectionId;
  }

  getSectionIdList() {
    const user = this.getCurrentUser();
    return JSON.parse(user.sectionIdList);
  }

  isPromotionManager() {
    return this.findByRoleName("Tanıtım Müdürü");
  }

  isRegionalDirector() {
    return this.findByRoleName("Bölge Müdürü");
  }

  findByRoleName(roleName) {
    const user = this.getCurrentUser();
    if (user)
      return JSON.parse(user.Roles).find((r) => r.Name === roleName) != null;
  }

  logout() {
    this.authData = null;
  }
}

export default LocalStorageService;
